import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex sm:flex-row flex-column justify-content-between w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Administrare"),
  /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Configurări aplicație")
], -1)
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "stat-div" }
const _hoisted_5 = { class: "app-inner-container" }
const _hoisted_6 = { class: "details-container" }
const _hoisted_7 = { class: "form-left-content" }
const _hoisted_8 = { class: "details-container" }
const _hoisted_9 = { class: "form-left-content" }
const _hoisted_10 = { class: "details-container" }
const _hoisted_11 = { class: "form-left-content" }
const _hoisted_12 = { class: "details-container" }
const _hoisted_13 = { class: "form-left-content" }

import { onMounted, ref, inject, VNodeRef } from 'vue';
import Editor from 'primevue/editor';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import { AppConfigServiceCtx } from '@/api';
import AppConfigService from '@/services/AppConfigService';
import { TermsAndConditions } from '@/interfaces/TermsAndConditions';
import { PlatformPolicies } from '@/interfaces/PlatformPolicies';
import Card from 'primevue/card';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigurationView',
  setup(__props) {

const confirm = useConfirm();
const toast = useToast();

const termsContent = ref<string | undefined>();
const termsDoctorContent = ref<string | undefined>();
const policiesContent = ref<string | undefined>();
const policiesDoctorContent = ref<string | undefined>();

const termsEditor = ref<VNodeRef | null>(null);
const termsDoctorEditor = ref<VNodeRef | null>(null);
const policiesEditor = ref<VNodeRef | null>(null);
const policiesDoctorEditor = ref<VNodeRef | null>(null);

const appConfigService: AppConfigService | undefined =
  inject(AppConfigServiceCtx);

const termsEditorLoad = () => {
  if (termsEditor.value) {
    const delta = termsEditor.value.quill.clipboard.convert({
      html: termsContent.value
    });
    termsEditor.value.quill.setContents(delta, 'silent');
  }
};

const termsDoctorEditorLoad = () => {
  if (termsDoctorEditor.value) {
    const delta = termsDoctorEditor.value.quill.clipboard.convert({
      html: termsDoctorContent.value
    });
    termsDoctorEditor.value.quill.setContents(delta, 'silent');
  }
};

const policiesEditorLoad = () => {
  if (policiesEditor.value) {
    const delta = policiesEditor.value.quill.clipboard.convert({
      html: policiesContent.value
    });
    policiesEditor.value.quill.setContents(delta, 'silent');
  }
};

const policiesDoctorEditorLoad = () => {
  if (policiesDoctorEditor.value) {
    const delta = policiesDoctorEditor.value.quill.clipboard.convert({
      html: policiesDoctorContent.value
    });
    policiesDoctorEditor.value.quill.setContents(delta, 'silent');
  }
};

const askForUpdateTermsAndConditions = () => {
  confirm.require({
    message:
      'Suneti sigur ca doriti sa actualizati termenii, conditiile si politicile platformei?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    acceptClass: 'p-button-danger',
    rejectLabel: 'Nu',
    rejectClass: 'p-button-secondary',
    accept: () => {
      try {
        updateTermsAndConditions();
        updateTermsAndConditionsForDoctor();
        updatePlatformPolicies();
        updatePlatformPoliciesForDoctor();
        showSuccess();
        setTimeout(() => {
          location.reload();
        }, 2000);
      } catch {
        showError(
          'Nu s-au putut actualiza termenii, conditiile si politicile plaformei'
        );
      }
    }
  });
};

const updateTermsAndConditions = () => {
  if (!termsContent.value) {
    showError('Continutul termenilor si conditiilor este gol');
    return;
  }

  const updatedTerms: TermsAndConditions = {
    content: termsContent.value
  };
  appConfigService?.updateTermsAndConditions(updatedTerms);
};

const updateTermsAndConditionsForDoctor = () => {
  if (!termsDoctorContent.value) {
    showError('Continutul termenilor si conditiilor pentru medici este gol');
    return;
  }

  const updatedDoctorTerms: TermsAndConditions = {
    content: termsDoctorContent.value
  };
  appConfigService?.updateTermsAndConditionsForDoctor(updatedDoctorTerms);
};

const updatePlatformPolicies = () => {
  if (!policiesContent.value) {
    showError('Continutul politicilor platformei este gol');
    return;
  }

  const updatedPolicies: PlatformPolicies = {
    content: policiesContent.value
  };
  appConfigService?.updatePlatformPolicies(updatedPolicies);
};

const updatePlatformPoliciesForDoctor = () => {
  if (!policiesDoctorContent.value) {
    showError('Continutul politicilor platformei pentru medici este gol');
    return;
  }

  const updatedDoctorPolicies: PlatformPolicies = {
    content: policiesDoctorContent.value
  };
  appConfigService?.updatePlatformPoliciesForDoctor(updatedDoctorPolicies);
};

const showError = (message: string): void => {
  toast.add({
    severity: 'error',
    summary: 'A aparut o eroare!',
    detail: message,
    life: 3000
  });
};

const showSuccess = (): void => {
  toast.add({
    severity: 'success',
    summary: 'Actiune realizata cu succes!',
    detail: 'Termenii, conditiile si politicile plaformei au fost actualizate',
    life: 3000
  });
};

onMounted(async () => {
  const tc: TermsAndConditions | undefined =
    await appConfigService?.fetchTermsAndConditions();
  if (tc != null && tc.content) {
    termsContent.value = tc.content;
  }
  const tcDoctor: TermsAndConditions | undefined =
    await appConfigService?.fetchTermsAndConditionsForDoctor();
  if (tcDoctor != null && tcDoctor.content) {
    termsDoctorContent.value = tcDoctor.content;
  }
  const pc: PlatformPolicies | undefined =
    await appConfigService?.fetchPlatformPolicies();
  if (pc != null && pc.content) {
    policiesContent.value = pc.content;
  }
  const pcDoctor: PlatformPolicies | undefined =
    await appConfigService?.fetchPlatformPoliciesForDoctor();
  if (pcDoctor != null && pcDoctor.content) {
    policiesDoctorContent.value = pcDoctor.content;
  }

  setTimeout(() => {
    termsEditorLoad();
    termsDoctorEditorLoad();
    policiesEditorLoad();
    policiesDoctorEditorLoad();
  }, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Button), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (askForUpdateTermsAndConditions())),
              class: "p-button-md",
              label: "Salvează",
              icon: "pi pi-save",
              outlined: ""
            })
          ])
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(TabView), null, {
          default: _withCtx(() => [
            _createVNode(_unref(TabPanel), { header: "Termeni si conditii - PACIENT" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(Editor), {
                      ref_key: "termsEditor",
                      ref: termsEditor,
                      onLoad: termsEditorLoad,
                      modelValue: termsContent.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((termsContent).value = $event)),
                      editorStyle: "height: 500px"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "Termeni si conditii - MEDIC" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(Editor), {
                      ref_key: "termsDoctorEditor",
                      ref: termsDoctorEditor,
                      onLoad: termsDoctorEditorLoad,
                      modelValue: termsDoctorContent.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((termsDoctorContent).value = $event)),
                      editorStyle: "height: 500px"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "Politici platforma - PACIENT" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(Editor), {
                      ref_key: "policiesEditor",
                      ref: policiesEditor,
                      onLoad: policiesEditorLoad,
                      modelValue: policiesContent.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((policiesContent).value = $event)),
                      editorStyle: "height: 500px"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "Politici platforma - MEDIC" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(Editor), {
                      ref_key: "policiesDoctorEditor",
                      ref: policiesDoctorEditor,
                      onLoad: policiesDoctorEditorLoad,
                      modelValue: policiesDoctorContent.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((policiesDoctorContent).value = $event)),
                      editorStyle: "height: 500px"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(ConfirmDialog)),
      _createVNode(_unref(Toast))
    ]),
    _: 1
  }))
}
}

})